import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

// Components
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

// Styles
import styles from "./contact-us-proroduct-stock-price-match.module.scss";

function ContactUsProductStockPriceMatch({ solution: { id, title }, className }) {
  return (
    <article className={classnames(styles.standardSolution, className)} data-solution-id={id}>
      <div className={styles.standardSolution__inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        <div className={styles.priceMatchSection}>
          <h2>Price match request</h2>
          <p>
            You can submit a price match request online. Find out more about our{" "}
            <a href="https://www.johnlewis.com/customer-services/prices-and-payment/never-knowingly-undersold">
              price match policy
            </a>
            .
          </p>
          <PrimaryButton
            tag="a"
            href="https://www.johnlewis.com/customer-services/prices-and-payment/never-knowingly-undersold-claim"
            className={styles.priceMatch__button}
          >
            Request a price match
          </PrimaryButton>
        </div>
      </div>
    </article>
  );
}

ContactUsProductStockPriceMatch.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    buttonType: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

ContactUsProductStockPriceMatch.defaultProps = {
  className: undefined,
};

export default ContactUsProductStockPriceMatch;
